import { render } from "./ModalElaboracionComponent.vue?vue&type=template&id=198dce44"
import script from "./ModalElaboracionComponent.vue?vue&type=script&lang=js"
export * from "./ModalElaboracionComponent.vue?vue&type=script&lang=js"

import "./ModalElaboracionComponent.vue?vue&type=style&index=0&id=198dce44&lang=css"

import exportComponent from "C:\\Users\\anton\\Desktop\\cangas_de_narcea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__